module.exports = "<div class=custom-typeahead-wrapper> <input ng-model=$ctrl.selectedDisplay typeahead-min-length=1 typeahead-on-select=$ctrl.onSelect($item) uib-typeahead=\"item[$ctrl.itemDisplayProp] for item in $ctrl.itemList | filter: $viewValue\" class=form-control placeholder=\"{{ $ctrl.emptyDisplayName }}\" type=text>  </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/custom-typeahead/custom-typeahead.html
// module id = 338
// module chunks = 0